// extracted by mini-css-extract-plugin
export default {"lightAnimation":"LightAnimation_lightAnimation__s4PLC","lightning":"LightAnimation_lightning__1nXq8"};